import { mergeStyles } from '@fluentui/react';
import React, { useEffect, useState } from 'react';
import { BwjPill } from '../bwj-pill';
import { BwjPillSize, BwjPillSizes } from '../bwj-pill/pill-sizes';

export interface IBwjPillboxProps {
    content: any[];
    getKey: (content: any) => string;
    toContentString?: (content: any) => string;
    onRenderContent?: (content: any) => JSX.Element;
    size?: BwjPillSize;
    onPillClick?: (content: any) => void;
    onActionButtonClick?: (content: any) => void;
    actionButtonIcon?: string;
    disabled?: boolean;
}

export const BwjPillbox: React.FunctionComponent<IBwjPillboxProps> = (props) => {
    const { size } = props;
    const [pillboxClass, setPillboxClass] = useState('');

    useEffect(() => {
        const pillSize = size ?? BwjPillSizes.regular;

        setPillboxClass(mergeStyles([{
            display: 'flex',
            flexWrap: 'wrap',
            padding: 0,
            paddingTop: pillSize / 2,
            paddingLeft: pillSize / 2,
        }]));

    }, [size]);

  return (
    <div className={pillboxClass}>
        {props.content.map(item => 
            <BwjPill
                key={props.getKey(item)}
                content={item}
                toContentString={props.toContentString}
                onRenderContent={props.onRenderContent}
                size={props.size}
                onPillClick={props.onPillClick}
                onActionButtonClick={props.onActionButtonClick}
                actionButtonIcon={props.actionButtonIcon}
                disabled={props.disabled}
            />
        )}
    </div>
  );
};
